<template>
  <div class="homePage">
    <Loader v-if="loading" />

    <div v-else>
      <div v-if="noData">
        <p class="text-center">
          {{ $t("welcomeMsg") }}
        </p>
      </div>
      <NoData v-if="noData" />

      <div class="" ref="main_wrapper" v-else>
        <the-filter :inputs="inputs" />
        <div class="row fadeIn">
          <!-- End:: Aside -->
          <div class="col-12 py-0">
            <main>
              <div class="row">
                <div
                  class="col-lg-4 col-md-6 col-12"
                  v-for="card in cards"
                  :key="card.id"
                >
                  <simple-card classes="w-100 ">
                    <statistics-card
                      :item="card"
                      :color="getRandomColor(colors)"
                    />
                  </simple-card>
                </div>
              </div>

              <div v-show="true" class="row">
                <div class="col-12">
                  <simple-card classes="w-100 m-0">
                    <main>
                      <v-data-table
                        class="thumb strip"
                        :headers="top_rider_headers"
                        :items="most_products_orders"
                        :loading="loading"
                        :loading-text="$t('table.loadingData')"
                        item-key="id"
                        hide-default-footer
                        disable-pagination
                      >
                        <template v-slot:[`item.index`]="{ index }">
                          {{ index + 1 }}
                        </template>
                        <template v-slot:[`item.image`]="{ item, index }">
                          <img
                            @click="show_model_1(item?.image)"
                            class="image"
                            @error="imageError(index)"
                            :src="item?.image"
                            v-if="item?.image"
                          />
                          <span class="redColor fontBold" v-else>{{
                            $t("notFound")
                          }}</span>
                        </template>

                        <template v-slot:[`item.product_name`]="{ item }">
                          <span v-if="item.product_name">
                            <span>
                              {{ item.product_name }}
                            </span>
                          </span>
                          <span class="redColor fontBold" v-else>{{
                            $t("notFound")
                          }}</span>
                        </template>
                        <template v-slot:[`item.quantity`]="{ item }">
                          <span v-if="item.quantity">
                            {{ item.quantity }}
                          </span>
                          <span class="redColor fontBold" v-else>{{
                            $t("notFound")
                          }}</span>
                        </template>

                        <!-- Select no data State -->
                        <template v-slot:no-data>
                          {{ $t("table.noData") }}
                        </template>

                        <!-- IsActive -->
                        <template v-slot:[`item.is_active`]="{ item }">
                          <span
                            class="status"
                            :class="item.is_active ? 'active' : 'inactive'"
                          >
                            {{ helper_boolToText(item.is_active) }}
                          </span>
                        </template>

                        <template
                          v-slot:[`item.phone_complete_form`]="{ item }"
                        >
                          <a
                            :href="`tel:${item.phone_complete_form}`"
                            v-if="item.phone_complete_form"
                            ><bdi> {{ item.phone_complete_form }}</bdi></a
                          >
                          <span class="redColor fontBold" v-else>{{
                            $t("notFound")
                          }}</span>
                        </template>
                        <template v-slot:[`item.status`]="{ item }">
                          <span v-if="item.status">
                            {{ $t(`${item.status}`) }}</span
                          >
                          <span class="redColor fontBold" v-else>{{
                            $t("notFound")
                          }}</span>
                        </template>

                        <template v-slot:[`item.actions`]="{ item }">
                          <div class="_actions">
                            <router-link
                              :to="`/products/show/${item.product_id}`"
                            >
                              <v-icon class="show" small> fal fa-eye </v-icon>
                            </router-link>
                          </div>
                        </template>
                        <!-- ======================== Start Top Section ======================== -->
                        <template v-slot:top>
                          <h3 class="table-title title">
                            {{ $t("labels.topProduct") }}
                          </h3>
                          <!-- Delete dialog -->

                          <!-- Add & Delete -->
                          <v-row>
                            <v-col cols="12" sm="8"></v-col>
                          </v-row>
                        </template>
                        <!-- ======================== End Top Section ======================== -->
                      </v-data-table>
                    </main>
                  </simple-card>
                </div>

                <div class="col-12">
                  <simple-card classes="w-100 m-0">
                    <main>
                      <v-data-table
                        class="thumb strip"
                        :headers="top_client_order_header"
                        :items="top_client_order"
                        :loading="loading"
                        :loading-text="$t('table.loadingData')"
                        item-key="id"
                        hide-default-footer
                        disable-pagination
                      >
                        <template v-slot:[`item.index`]="{ index }">
                          {{ index + 1 }}
                        </template>
                        <template v-slot:[`item.image`]="{ item, index }">
                          <img
                            @click="show_model_1(item.image)"
                            class="image"
                            @error="imageError(index)"
                            :src="item.image"
                            v-if="item.image"
                          />
                          <span class="redColor fontBold" v-else>{{
                            $t("notFound")
                          }}</span>
                        </template>

                        <template v-slot:[`item.name`]="{ item }">
                          <router-link
                            v-if="item.name"
                            :to="`/clients/show/${item?.id}`"
                          >
                            <span>
                              {{ item.name }}
                            </span>
                          </router-link>
                          <span class="redColor fontBold" v-else>{{
                            $t("notFound")
                          }}</span>
                        </template>
                        <template v-slot:[`item.order_count`]="{ item }">
                          <span v-if="item.order_count">
                            {{ item.order_count }}
                          </span>

                          <span class="redColor fontBold" v-else>{{
                            $t("notFound")
                          }}</span>
                        </template>
                        <template v-slot:[`item.phone`]="{ item }">
                          <a :href="`tel:${item.phone}`" v-if="item.phone"
                            ><bdi> {{ item.phone }}</bdi></a
                          >
                          <span class="redColor fontBold" v-else>{{
                            $t("notFound")
                          }}</span>
                        </template>

                        <!-- Select no data State -->
                        <template v-slot:no-data>
                          {{ $t("table.noData") }}
                        </template>

                        <!-- IsActive -->
                        <template v-slot:[`item.is_active`]="{ item }">
                          <span
                            class="status"
                            :class="item.is_active ? 'active' : 'inactive'"
                          >
                            {{ helper_boolToText(item.is_active) }}
                          </span>
                        </template>

                        <template v-slot:[`item.actions`]="{ item }">
                          <div class="_actions">
                            <router-link :to="`/clients/show/${item.id}`">
                              <v-icon class="show" small> fal fa-eye </v-icon>
                            </router-link>
                          </div>
                        </template>

                        <!-- ======================== Start Top Section ======================== -->
                        <template v-slot:top>
                          <h3 class="table-title title">
                            {{ $t("labels.topRiders") }}
                          </h3>
                          <!-- Delete dialog -->

                          <!-- Add & Delete -->
                          <v-row>
                            <v-col cols="12" sm="8"></v-col>
                          </v-row>
                        </template>
                        <!-- ======================== End Top Section ======================== -->
                      </v-data-table>
                    </main>
                  </simple-card>
                </div>
              </div>
            </main>
          </div>
        </div>
        <div class="row mb-10">
          <div class="col-lg-12">
            <simple-card classes="p-0 w-100 h-100" v-if="orders">
              <div class="col-12 h-full">
                <AreaCharts
                  dir="ltr"
                  ChartHeigh="320px !important"
                  :ShapeType="'area'"
                  :ChartType="'smooth'"
                  :ChartColors="['#ffb427', '#ffb427']"
                  :ChartLabels="orders?.orders_per_day?.labels.map((x) => x)"
                  :ChartData="[
                    { name: 'Orders', data: orders?.orders_per_day?.series },
                  ]"
                >
                </AreaCharts>
              </div>
            </simple-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartsAside from "@/components/Layouts/ChartsAside.vue";
import Loader from "@/components/Loaders/loader.vue";

import AreaCharts from "@/components/Charts/AreaCharts.vue";
import ColumnChart from "@/components/Charts/ColumnChart.vue";

export default {
  name: "HomePage",

  components: {
    ChartsAside,
    AreaCharts,
    ColumnChart,
    Loader,
  },

  data() {
    return {
      colors: [
        {
          first: "#62EAE1",
          secound: "rgba(126, 229, 223, 0)",
        },
        {
          first: "#FF6370",
          secound: "rgba(255, 99, 112, 0)",
        },
        {
          first: "#9E62EA",
          secound: " #B199ED",
        },
        {
          first: "#EABC62",
          secound: "#E9BA62",
        },
      ],

      // ========== Charts Aside
      asideIsActive: false,
      // start of main loader
      noData: true,
      loading: false,
      // end of main loader
      // ============ Charts Data
      cards: [],
      orders: null,
      // employees: {
      //   key: null,
      //   route: "employees/show-all",
      //   title: "عدد الموظفين",
      //   count: null,
      // },
      notifications_states: [],
      charts: [],
      top_cards: [],
      recently_partner: [],
      recently_rider: [],
      top_vehicle_package: [],
      top_partners: [],
      most_products_orders: [],
      top_client_order: [],
      chartsData: null,
      inputs: [
        {
          keyName: "duration",
          status: [
            { id: "", name: this.$t("all") },
            { id: "24 hr", name: this.$t("24hr") },
            { id: "1 week", name: this.$t("1week") },
            { id: "1 month", name: this.$t("1month") },
            { id: "3 months", name: this.$t("3months") },
            { id: "6 months", name: this.$t("6months") },
            { id: "1 year", name: this.$t("1year") },
          ],
        },
      ],
      top_rider_headers: [
        {
          text: "الصورة",
          align: "center",
          value: "image",
          sortable: false,
        },
        {
          text: this.$t("labels.name"),
          value: "product_name",
          align: "center",
          sortable: false,
        },

        {
          text: this.$t("labels.quantity"),
          value: "quantity",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("labels.status"),
          align: "center",
          value: "status",
          sortable: false,
        },
        // {
        //   text: this.$t("labels.activation"),
        //   align: "center",
        //   value: "is_active",
        //   sortable: false,
        // },
        {
          text: this.$t("labels.control"),
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],

      top_client_order_header: [
        // {
        //   text: "الصورة",
        //   align: "center",
        //   value: "image",
        //   sortable: false,
        // },
        {
          text: this.$t("labels.fullname"),
          value: "name",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("labels.order_count"),
          value: "order_count",
          align: "center",
          sortable: false,
        },

        {
          text: this.$t("labels.phone"),
          align: "center",
          value: "phone",
          sortable: false,
        },
        // {
        //   text: this.$t("labels.is_active"),
        //   align: "center",
        //   value: "is_active",
        //   sortable: false,
        // },
        {
          text: this.$t("labels.control"),
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    user() {
      return this.$store.getters["auth_module/currentUser"];
    },
  },

  methods: {
    toggleAside() {
      this.asideIsActive = !this.asideIsActive;
    },
    getRouteLink(item) {
      let link;
      if (item.notify_type == "new_trip") {
        link = "trips";
      } else if (item.notify_type == "new_rider") {
        link = "riders";
      } else if (item.notify_type == "new_partner") {
        link = "partners";
      } else if (item.notify_type == "finish_trip") {
        link = "trips";
      }

      return link;
    },
    getHome() {
      this.canShow = this.$permission.allowed("report");
      console.log(!this.canShow);
      if (!this.canShow) {
        this.loading = true;
        this.noData = false;
        this.axios({
          method: "GET",
          url: "/reports",
          params: {
            duration: this.$route.query.duration,
          },
        })
          .then((res) => {
            this.noData = false;
            this.cards = res.data.data.cards;
            this.orders = res.data.data.orders;
            this.orders?.ordersPerDay?.labels.map((x) => console.log(x));
            this.most_products_orders = res.data.data.most_products_orders;
            this.top_client_order = res.data.data.top_client_order;

            // this.employees.count = res.data.data.employees.count;
            this.loading = false;
          })
          .catch((err) => {
            this.noData = true;
            this.loading = false;
            this.$iziToast.error({
              displayMode: 2,
              title: this.$t("error"),
              message:
                err.response?.data.message ?? err.response?.data.messages,
            });
          });
      }
    },

    getRandomColor(colors) {
      let random = Math.floor(Math.random() * 4);

      return { colors: colors[random], id: random };
    },

    imageError(index) {
      this.rows[
        index
      ].image = require("@/assets/media/images/Icons/no-data.png");
    },

    getPermissions() {
      this.axios.get("account/permissions").then((res) => {
        localStorage.setItem(
          "m7_dash_permissions",
          JSON.stringify(res.data.data)
        );
        // this.getSideBar();
      });
    },

    getSideBar() {
      this.axios.get("admin_side_bar").then((res) => {
        this.$router.push(`/${res.data[0].categories[0].permissions[0].url}`);
      });
    },
  },
  watch: {
    [`$route`]() {
      if (this.$route.query.duration) {
        this.getHome();
      }
    },
  },
  created() {
    if (this.user.usertype != "superadmin") {
      // this.getPermissions();
      // this.getControls();
      this.getHome();
    } else {
      this.getHome();
      if (localStorage.getItem("m7_dash_permissions")) {
        localStorage.removeItem("m7_dash_permissions");
      }
    }
  },
};
</script>

<style scoped lang="scss">
.stats_chart {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
  // justify-content: space-c;
  padding: 15px;

  // flex-direction: row-reverse;
  .icon {
    width: 50px;
    height: 50px;

    display: flex;
    justify-content: center;
    align-items: center;
    margin-inline-end: 1rem;
  }

  .content {
    display: flex;
    flex-direction: column;

    .value {
      font-style: normal;
      font-weight: 500;
      font-size: 22px;
      line-height: 27px;
      color: #000;
    }

    .name {
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 18px;
      margin-bottom: 8px;
      color: var(--mainText);
    }

    .values {
      margin-top: 0.5rem;

      span {
        color: var(--main);
        font-weight: 700;
        font-size: 1rem;
      }
    }
  }
}

.notifications_states {
  header {
    border-bottom: 1px solid #efefef !important;

    .title {
      font-style: normal;
      font-weight: 400;
      font-size: 16px !important;
      line-height: 20px;
      color: #000;
    }
  }

  .content {
    min-height: 200px;
    max-height: 250px;
    overflow-y: auto;
    padding-block: 8px;

    .notification_card {
      .state {
        display: flex;
        align-items: center;

        .notification_content {
          margin-inline-start: 8px;

          .title {
            display: block;
            font-style: normal;
            font-weight: 400;
            font-size: 12px !important;
            line-height: 17px;
            color: #000;
            margin: 0;
            margin-bottom: 5px;
          }

          p,
          a {
            font-style: normal;
            font-weight: 400 !important;
            font-size: 10px !important;
            line-height: 15px;
            color: var(--mainText);
            margin: 0;
          }
        }

        &:not(:last-child) {
          margin-bottom: 8px;
        }
      }

      .no-data {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        h4 {
          font-size: 18px !important;
        }
      }
    }
  }

  footer {
    text-align: center;
    border-top: 1px solid #efefef !important;

    a {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: var(--mainText);
    }
  }

  &.client {
    .content {
      min-height: 250px;
      max-height: 250px;
    }
  }
}
</style>
